import { Button } from "../UI/Buttons/Button";
import GoogleIcon from "@/assets/icons/google.svg?react";
import { useState } from "react";
import { ErrorMessage } from "../UI";
import { cn } from "@/lib/utils";
import socialAuthService from "@/services/socialAuthService";
import { Spinner } from "../UI/Spinner";

const GoogleAuthButton = ({
  className,
  buttonClassName,
}: {
  className?: string;
  buttonClassName?: string;
}) => {
  const [isUrlLoading, setIsUrlLoading] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>();

  const navigateToAuthPage = async () => {
    setErrorMsg(undefined);
    setIsUrlLoading(true);

    try {
      const authUrl = await socialAuthService.getGoogleAuthUrl();
      window.location.href = authUrl;
    } catch (error: any) {
      setErrorMsg(error.message || "Nepavyko prisijungti su Google");
      setIsUrlLoading(false);
    }
  };

  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <Button
        variant="white"
        size="checkout"
        type="button"
        className={cn(
          "text-ink border-line bg-white text-[18px] md:text-[18px]",
          buttonClassName,
        )}
        onClick={navigateToAuthPage}
      >
        {isUrlLoading && <Spinner className="size-6" />}
        Tęsti su Google
        <GoogleIcon className="size-6!" />
      </Button>

      <ErrorMessage error={errorMsg} />
    </div>
  );
};

export default GoogleAuthButton;
